<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<p class="part"><span href="#/OEBPS/toc#p02" id="pt2" title="Link target outside of Sample"><strong>PART TWO</strong></span></p>
<p class="part1"><span href="#/OEBPS/toc#p02" title="Link target outside of Sample"><strong>JUDENPOLITIK 1934–1938</strong></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p02.vue?09ca986f